import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

/* istanbul ignore file */

export function getInfuseConfig() {
  return from(axios.post('/authentication/security/getInfuseSystemOptions')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
}

export function auditInfuseHandShakeStatus(running) {
  const auditMessage = `Infuse HandShake is ${running ? '' : 'NOT'} running`.replace(/\s+/g, ' ');

  return from(
    axios.post('/authentication/security/auditInfuseHandShakeStatus', { auditMessage })
  ).pipe(map(({ data: { data, success } }) => ({ data, success })));
}

export function getInfuseSpotConfig() {
  return from(axios.post('/authentication/public/getInfuseSystemOptions')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
}
